import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck, LogIn } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useSettings } from "@/context/SettingsContext";
import { formatApiError } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const { panel_title } = useSettings();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (e) {
      setErr(formatApiError(e));
    }
    setBusy(false);
  };

  return (
    <div className="min-h-screen grid place-items-center bg-bg relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(225,29,72,0.08),transparent_50%),radial-gradient(circle_at_80%_80%,rgba(225,29,72,0.06),transparent_50%)] pointer-events-none" />
      <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:48px_48px] pointer-events-none" />

      <form
        onSubmit={submit}
        className="relative z-10 w-full max-w-sm bg-surface border border-border rounded-xl p-8 shadow-[0_20px_60px_rgba(0,0,0,0.5)]"
        data-testid="login-form"
      >
        <div className="flex items-center gap-3 mb-8">
          <div className="w-11 h-11 rounded-md bg-gradient-to-br from-brand to-brand-hover grid place-items-center shadow-[0_0_28px_rgba(225,29,72,0.45)]">
            <ShieldCheck className="w-5 h-5 text-white" />
          </div>
          <div className="leading-tight">
            <div className="font-display font-bold text-2xl tracking-tight">{panel_title}</div>
            <div className="text-[10px] font-mono text-brand tracking-widest uppercase">Yönetim Paneli</div>
          </div>
        </div>

        <div className="space-y-4">
          <div>
            <label className="block text-[11px] font-mono uppercase tracking-widest text-ink-dim mb-2">E-posta</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email"
              className="w-full px-4 py-2.5 rounded-md bg-bg border border-border focus:border-brand focus:outline-none text-sm font-mono"
              placeholder="admin@…"
            />
          </div>
          <div>
            <label className="block text-[11px] font-mono uppercase tracking-widest text-ink-dim mb-2">Şifre</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password"
              className="w-full px-4 py-2.5 rounded-md bg-bg border border-border focus:border-brand focus:outline-none text-sm font-mono"
              placeholder="••••••••"
            />
          </div>
          {err && (
            <div className="text-err text-xs p-3 rounded-md bg-err/10 border border-err/30" data-testid="login-error">
              {err}
            </div>
          )}
          <button
            type="submit"
            disabled={busy}
            data-testid="login-submit"
            className="w-full flex items-center justify-center gap-2 px-4 py-2.5 rounded-md bg-brand hover:bg-brand-hover text-sm font-medium disabled:opacity-50 transition"
          >
            <LogIn className="w-4 h-4" />
            {busy ? "Giriş yapılıyor…" : "Giriş Yap"}
          </button>
        </div>

        <div className="mt-6 pt-6 border-t border-border text-[10px] font-mono text-ink-faint leading-relaxed">
          Bu panel Swiss IPTV Guard / Titan Streaming OS yönetim arayüzüdür. Yetkisiz erişim yasaktır.
        </div>
      </form>
    </div>
  );
}
